import { ReactNode } from "react";

/** Sparkle first, then whatever MUI already placed there (selected tags in `multiple` mode). */
export function combineStartAdornments(sparkle: ReactNode, existing: ReactNode): ReactNode {
  if (!sparkle) {
    return existing;
  }
  if (!existing) {
    return sparkle;
  }
  return (
    <>
      {sparkle}
      {existing}
    </>
  );
}
